import { PublicBlockOccurrence, PublicOccurrence } from '@cademy-package/sdk-component-types';

export const isBlockOccurrence = (
    occurrence: PublicOccurrence
): occurrence is PublicBlockOccurrence => {
    return occurrence.is_block === true;
};
